import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormGroupExt } from '../../../../app/form-ext/form-group.ext';
import { HTMLInputEvent } from '../../../../app/interfaces/HTMLInputEvent';
import { ToastService } from '../../../services/toast.service';

@Component({
    selector: 'app-single-attachment-browser',
    templateUrl: './single-attachment-browser.component.html',
    styleUrls: ['./single-attachment-browser.component.scss'],
    standalone: false,
})
export class SingleAttachmentBrowserComponent {
    @ViewChild('uploadInputElement') fileBrowserInput: ElementRef;

    @Input() public formGroupExtContainer: FormGroupExt;
    @Input() public attachmentControlName: string;
    @Input() public browseButtonDisabled: boolean;
    @Input() public maxSize = 25; /* MB */
    @Input() public extensionsAllowed: string[];
    @Input() public mimeTypesAllowed: string[];

    public constructor(private toastService: ToastService) {}

    public get AttachmentControl(): AbstractControl | null {
        return this.formGroupExtContainer.group.get(this.attachmentControlName);
    }

    public onAttachmentUpload($event: Event): void {
        const htmlInputEvent = $event as HTMLInputEvent;
        const fileList = htmlInputEvent.target.files || null;

        if (!fileList?.length || fileList[0] === null) {
            /* no files have been selected to be uploaded */
            return;
        }

        const file = fileList[0];

        /* reset file input so that the (change) event will get triggered again next time */
        this.fileBrowserInput.nativeElement.value = '';
        this.addAttachmentToForm(file);
    }

    public removeAttachment(): void {
        this.AttachmentControl?.setValue(null);
    }

    private addAttachmentToForm(file: File): void {
        if (!this.mimeTypesAllowed.includes(file.type)) {
            this.toastService.showError($localize`File type not supported`, {
                duration: 5000,
            });
            return;
        }

        if (file.size > this.maxSize * 1024 * 1024) {
            this.toastService.showError($localize`File size exceeds ${this.maxSize} MB`, { duration: 5000 });
            return;
        }

        this.AttachmentControl?.setValue(file);
    }
}
